// @ts-ignore not converted yet
import { reportError } from 'ContentUtils/helpers/sentry';
import { fetchPublicPlayer } from '../utils/api';
import { FETCH_VIDEO_SUCCESS, FETCH_VIDEO_FAILED, FETCH_VIDEO_ATTEMPTED, SET_PLAYER_ERROR, CONFIRMED_VISIBLE } from './ActionTypes';
import { loadCaptions } from './captions';
import createUsageTracker, { getPlayerTypeForTracking } from '../utils/tracker';

// todo temporary workaround until backend ensures first chapter starts at 0 https://git.hubteam.com/HubSpot/MediaContent/issues/1936
const sanitizeChapters = (chapters, duration) => {
  var _sortedChapters$;
  const sortedChapters = [...chapters].filter(chapter => chapter.startTime <= duration / 1000).sort((a, b) => a.startTime - b.startTime);
  if (((_sortedChapters$ = sortedChapters[0]) === null || _sortedChapters$ === void 0 ? void 0 : _sortedChapters$.startTime) > 0) {
    sortedChapters[0].startTime = 0;
  }
  return sortedChapters;
};
export const loadVideo = (videoId, params) => dispatch => {
  const parentDomain = params.parentOrigin ? params.parentOrigin.replace(/^https?:\/\//, '') : null;
  const usageTracker = createUsageTracker();
  dispatch({
    type: FETCH_VIDEO_ATTEMPTED
  });
  fetchPublicPlayer(videoId, {
    parentDomain
  }, params.authContext).then(player => {
    var _player$video$chapter;
    dispatch(Object.assign({
      type: FETCH_VIDEO_SUCCESS
    }, player));
    dispatch(loadCaptions(videoId, params)).catch(console.error);
    if ((_player$video$chapter = player.video.chapters) !== null && _player$video$chapter !== void 0 && _player$video$chapter.items) {
      player.video.chapters.items = sanitizeChapters(player.video.chapters.items, player.video.duration);
    }
    usageTracker.track('videoLoaded', {
      playerType: getPlayerTypeForTracking(player.video),
      duration: typeof window.performance.now === 'function' ? window.performance.now() : undefined,
      success: true,
      statusCode: 200,
      viaQuickFetch: Boolean(window._usedQuickFetch)
    });
  }).catch(error => {
    var _error$cause;
    console.error('Video fetch failed', error);
    reportError(error, {
      errorId: FETCH_VIDEO_FAILED
    });
    const statusCode = error instanceof Error ? (_error$cause = error.cause) === null || _error$cause === void 0 ? void 0 : _error$cause.status : error.status;
    usageTracker.track('videoLoaded', {
      success: false,
      statusCode
    });
    dispatch({
      type: FETCH_VIDEO_FAILED,
      videoFetchError: error
    });
  });
};
export const setAppError = appError => ({
  type: SET_PLAYER_ERROR,
  appError
});
export const confirmVisible = () => ({
  type: CONFIRMED_VISIBLE
});